module.exports = __webpack_public_path__ + "img/howExtraBox-2.39dddc8.png";